import { BrowserRouter as Router } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';

import Homepage from './pages/Homepage/Homepage';
import AITagging from './pages/AITagging/AITagging';
import AllFeaturePage from './pages/AllFeaturePage/AllFeaturePage';
import Faq from './pages/Faq/Faq';
import Footer from './components/Footer/Footer';
import AssetDistribution from './components/AssetDistribution/AssetDistribution';
import AssetDiscovery from './components/AssetDiscovery/AssetDiscovery';
import Assetorganisation from './components/AssetOrganisation/Assetorganisation';
import Workflow from './components/Workflow/Workflow';
import Login from './components/Login/Login';
import AssetOrganization from './pages/AssetOrganization/AssetOrganization';
import AIIntelligence from './pages/AIIntelligence/AIIntelligence';
const publicUrl = import.meta.env.VITE_PUBLIC_URL || '/';

function App() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  useEffect(() => {
    if (isLoginOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isLoginOpen]);

  const handleLogin = () => {
    console.log('Login button clicked!');
    setIsLoginOpen(true);
  };

  return (
    <Router basename={publicUrl}>
      <div className="App">
        <div id="home">
          <Homepage handleLogin={handleLogin} />
        </div>
        <div id="how-it-works">
          <div id="ai-tagging">
            <AITagging />
          </div>
        </div>
        <div id="core-capabilities">
          <AllFeaturePage />
          <AssetOrganization/>
        </div>
        <div id="ai-intelligence">
          <AIIntelligence/>
        </div>
        <div id="help-faqs">
          <Faq />
        </div>
        <Footer />
        {isLoginOpen && <Login isLoginOpen={isLoginOpen} setIsLoginOpen={setIsLoginOpen} />}
      </div>
    </Router>
  );
}

export default App;
